(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yup-community"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yup-community-rail')) {
  customElements.define('yup-community-rail', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.yup-community-rail__viewport');
      this.track = this.querySelector('.yup-community-rail__track');
      this.group = this.querySelector('.yup-community-rail__group');
      if (!this.group?.children.length) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.resumeAt = 0;
      this.position = 0;
      this.auto = false;
      this.clones = [];
      for (let i = 0; i < 2; i++) {
        const clone = this.group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach(link => { link.tabIndex = -1; link.removeAttribute('data-shopify-editor-block'); });
        clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        if (i === 0) this.track.prepend(clone); else this.track.append(clone);
        this.clones.push(clone);
      }
      this.track.querySelectorAll('a,img').forEach(node => { node.draggable = false; });
      const measure = () => {
        const oldWidth = this.width || 1;
        const offset = this.width ? (this.viewport.scrollLeft % oldWidth) / oldWidth : 0;
        this.width = this.group.getBoundingClientRect().width;
        this.position = this.width * (1 + offset);
        this.viewport.scrollLeft = this.position;
      };
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches; }, options);
      this.viewport.addEventListener('pointerdown', event => {
        this.auto = false;
        this.pointerActive = true;
        this.focusWithin = false;
        this.dragged = false;
        this.startX = event.clientX;
        this.startScroll = this.viewport.scrollLeft;
      }, options);
      this.viewport.addEventListener('pointermove', event => {
        if (!this.pointerActive || event.pointerType !== 'mouse') return;
        const distance = this.startX - event.clientX;
        if (Math.abs(distance) > 6) {
          this.dragged = true;
          this.viewport.setPointerCapture(event.pointerId);
          this.viewport.classList.add('is-dragging');
          this.viewport.scrollLeft = this.startScroll + distance;
        }
      }, options);
      const release = () => { this.pointerActive = false; this.viewport.classList.remove('is-dragging'); this.resumeAt = performance.now() + 1800; };
      window.addEventListener('pointerup', release, options);
      window.addEventListener('pointercancel', release, options);
      this.viewport.addEventListener('click', event => { if (this.dragged) { event.preventDefault(); event.stopPropagation(); this.dragged = false; } }, { ...options, capture: true });
      this.viewport.addEventListener('focusin', event => { this.focusWithin = event.target.matches(':focus-visible'); this.auto = false; }, options);
      this.viewport.addEventListener('focusout', event => { this.focusWithin = this.viewport.contains(event.relatedTarget); }, options);
      this.viewport.addEventListener('wheel', () => { this.auto = false; this.resumeAt = performance.now() + 1800; }, { ...options, passive: true });
      this.viewport.addEventListener('scroll', () => { if (!this.auto) { this.position = this.viewport.scrollLeft; this.resumeAt = performance.now() + 1800; } }, { ...options, passive: true });
      this.viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.auto = false;
          this.viewport.scrollBy({ left: event.key === 'ArrowRight' ? 220 : -220, behavior: this.motion.matches ? 'instant' : 'smooth' });
        }
      }, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, { threshold: 0.05 });
      this.observer.observe(this);
      this.resize = new ResizeObserver(measure);
      this.resize.observe(this.group);
      measure();
      const tick = now => {
        const elapsed = Math.min((now - (this.last || now)) / 1000, 0.05);
        this.last = now;
        if (this.width && !this.pointerActive) {
          if (this.viewport.scrollLeft < this.width * 0.5) { this.viewport.scrollLeft += this.width; this.position = this.viewport.scrollLeft; }
          else if (this.viewport.scrollLeft >= this.width * 1.5) { this.viewport.scrollLeft -= this.width; this.position = this.viewport.scrollLeft; }
        }
        if (this.visible && !document.hidden && !this.paused && !this.pointerActive && !this.focusWithin && now > this.resumeAt) {
          this.auto = true;
          this.position += elapsed * (Number(this.dataset.speed) || 35);
          this.viewport.scrollLeft = this.position;
        } else this.auto = false;
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); this.clones?.forEach(clone => clone.remove()); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yup-editorial-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yup-campaign-video')) {
  customElements.define('yup-campaign-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = true;
      this.video.controls = false;
      this.video.loop = true;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.setAttribute('muted', '');
      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('webkit-playsinline', '');
      this.tryPlay = () => {
        if (this.motion.matches || !this.visible || document.hidden) return;
        this.video.muted = true;
        const attempt = this.video.play();
        if (attempt) attempt.catch(() => {});
      };
      this.video.addEventListener('loadeddata', this.tryPlay, options);
      this.video.addEventListener('canplay', this.tryPlay, options);
      window.addEventListener('pageshow', this.tryPlay, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.video.pause(); else this.tryPlay(); }, options);
      document.addEventListener('pointerdown', this.tryPlay, options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.video.pause(); else this.tryPlay(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.tryPlay(); else this.video.pause();
      }, { threshold: 0.05 });
      this.observer.observe(this);
      if (this.motion.matches) this.video.pause(); else this.tryPlay();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.video?.pause(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
